(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ai-block-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-carousel-track]').forEach(function (track) {
      var id = track.dataset.carouselTrack;
      var prev = document.querySelector('[data-carousel-prev="' + id + '"]');
      var next = document.querySelector('[data-carousel-next="' + id + '"]');
      var sbThumb = document.querySelector('[data-carousel-scrollbar-thumb="' + id + '"]');

      function cardWidth() {
        var first = track.firstElementChild;
        if (!first) return 0;
        var gap = parseInt(getComputedStyle(track).gap) || 16;
        return first.getBoundingClientRect().width + gap;
      }

      function updateArrows() {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }

      function updateScrollbar() {
        if (!sbThumb) return;
        var scrollable = track.scrollWidth - track.clientWidth;
        if (scrollable <= 0) {
          sbThumb.style.width = '100%';
          sbThumb.style.left = '0%';
          return;
        }
        var ratio = track.clientWidth / track.scrollWidth;
        var progress = track.scrollLeft / scrollable;
        sbThumb.style.width = (ratio * 100) + '%';
        sbThumb.style.left = (progress * (100 - ratio * 100)) + '%';
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', function () {
        updateArrows();
        updateScrollbar();
      }, { passive: true });

      updateArrows();
      updateScrollbar();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coffee-landing-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const carousel = document.querySelector('[data-carousel]');
    if (!carousel) return;

    const slides = Array.from(carousel.querySelectorAll('.clh-slide'));
    const description = carousel.querySelector('.clh-description');
    const moreLink = carousel.querySelector('.clh-more');
    let current = 1;

    const descriptions = slides.map(s => s.dataset.description || '');
    const moreLinks = slides.map(s => s.dataset.moreLink || '#');

    function update() {
      slides.forEach((slide, i) => {
        slide.style.position = 'absolute';
        if (i === current) {
          slide.style.left = '50%';
          slide.style.right = 'auto';
          slide.style.bottom = '0';
          slide.style.zIndex = '3';
          slide.style.transform = 'translateX(-50%) scale(1)';
          slide.style.opacity = '1';
        } else if (i === (current - 1 + slides.length) % slides.length) {
          slide.style.left = '5%';
          slide.style.right = 'auto';
          slide.style.bottom = '0';
          slide.style.zIndex = '1';
          slide.style.transform = 'scale(0.75) translateX(-10%)';
          slide.style.opacity = '0.6';
        } else {
          slide.style.left = 'auto';
          slide.style.right = '5%';
          slide.style.bottom = '0';
          slide.style.zIndex = '1';
          slide.style.transform = 'scale(0.75) translateX(10%)';
          slide.style.opacity = '0.6';
        }
      });

      if (description && descriptions[current]) {
        description.textContent = descriptions[current];
      }
      if (moreLink && moreLinks[current]) {
        moreLink.href = moreLinks[current];
      }
    }

    carousel.querySelector('[data-prev]')?.addEventListener('click', () => {
      current = (current - 1 + slides.length) % slides.length;
      update();
    });

    carousel.querySelector('[data-next]')?.addEventListener('click', () => {
      current = (current + 1) % slides.length;
      update();
    });

    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
